import { Loader2 } from "lucide-react";

const STATUS = {
  healthy: "bg-emerald-500/15 text-emerald-600 border-emerald-500/20",
  success: "bg-emerald-500/15 text-emerald-600 border-emerald-500/20",
  Approved: "bg-emerald-500/15 text-emerald-600 border-emerald-500/20",
  warning: "bg-amber-500/15 text-amber-600 border-amber-500/20",
  pending: "bg-amber-500/15 text-amber-600 border-amber-500/20",
  Pending: "bg-amber-500/15 text-amber-600 border-amber-500/20",
  "Changes Requested": "bg-amber-500/15 text-amber-600 border-amber-500/20",
  critical: "bg-red-500/15 text-red-600 border-red-500/20",
  Rejected: "bg-red-500/15 text-red-600 border-red-500/20",
  Overdue: "bg-red-500/15 text-red-600 border-red-500/20",
  insufficient: "bg-hairline/10 text-subtle border-hairline/15",
  info: "bg-oraya-accent/15 text-oraya-accent border-oraya-accent/20",
};

export function StatusBadge({ status, label }) {
  const cls = STATUS[status] || "bg-hairline/10 text-subtle border-hairline/15";
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs border ${cls}`}>{label || status}</span>;
}

export function KpiCard({ label, value, prefix = "", empty, hint }) {
  return (
    <div className="glass-heavy rounded-2xl p-5 hover-lift" data-testid={`kpi-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <p className="text-xs uppercase tracking-[0.16em] text-subtle">{label}</p>
      {empty ? (
        <p className="text-subtle/70 text-sm mt-4">No data available yet</p>
      ) : (
        <p className="display text-3xl font-light text-ink mt-3">{prefix}{typeof value === "number" ? value.toLocaleString("en-IN") : value}</p>
      )}
      {hint && !empty && <p className="text-xs text-subtle mt-1">{hint}</p>}
    </div>
  );
}

export function EmptyState({ title = "No data available yet", hint, action }) {
  return (
    <div className="glass-medium rounded-2xl p-10 text-center" data-testid="empty-state">
      <p className="text-ink">{title}</p>
      {hint && <p className="text-subtle text-sm mt-2">{hint}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function LoadingState({ label = "Loading…" }) {
  return (
    <div className="flex items-center gap-2 text-subtle py-10 justify-center" data-testid="loading-state">
      <Loader2 className="w-4 h-4 animate-spin" /> {label}
    </div>
  );
}

export function CCButton({ children, onClick, variant = "primary", type = "button", disabled, testid, className = "" }) {
  const styles = {
    primary: "bg-invert text-invert-ink hover:opacity-90",
    ghost: "glass-medium text-ink hover:border-hairline/25",
    danger: "bg-red-500/15 text-red-600 border border-red-500/25 hover:bg-red-500/25",
  };
  return (
    <button type={type} onClick={onClick} disabled={disabled} data-testid={testid}
      className={`inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-medium transition-all disabled:opacity-50 ${styles[variant]} ${className}`}>
      {children}
    </button>
  );
}

export function Panel({ title, action, children, className = "", testid }) {
  return (
    <div className={`glass-heavy rounded-2xl p-6 ${className}`} data-testid={testid}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-5">
          {title && <h3 className="display text-lg font-medium text-ink">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-xs font-medium tracking-wide text-subtle uppercase">{label}</span>
      <div className="mt-1.5">{children}</div>
    </label>
  );
}

export const inputCls = "w-full bg-panel border border-hairline/15 rounded-lg px-3 py-2.5 text-ink focus:border-oraya-accent focus:outline-none transition-colors text-sm";
